export default "__VITE_ASSET__DFOEdXNN__"